var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"invisible",attrs:{"type":_vm.type},on:{"click":_vm.onClick}},[_c('vk-icon-button',{directives:[{name:"vk-tooltip",rawName:"v-vk-tooltip",value:(_vm.tooltip),expression:"tooltip"}],attrs:{"icon":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }